<div class="node-item" [class.has-children]="isGroup()">
    <div class="node-header" [class.drop-inside-active]="dragState.isInsideTarget(node)"
        (pointerenter)="onDropTargetEnter()" (pointerleave)="onDropTargetExit()">
        <button class="drag-handle" cdkDragHandle type="button" aria-label="Property verschieben"
            title="Property verschieben">
            <mat-icon>drag_indicator</mat-icon>
        </button>

        @if (isGroup()) {
        <button mat-icon-button class="expand-button" type="button" (click)="toggleExpand()"
            [attr.aria-label]="node.expanded ? 'Gruppe einklappen' : 'Gruppe ausklappen'">
            <mat-icon>{{ node.expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
        </button>
        } @else {
        <div class="spacer"></div>
        }

        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="small-field name-field">
            <mat-label>Name der Eigenschaft</mat-label>
            <input matInput [(ngModel)]="node.name" placeholder="Name der Eigenschaft" (ngModelChange)="onSelfChange()">
        </mat-form-field>

        @if (!isGroup()) {
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="small-field type-field">
            <mat-label>Datentyp</mat-label>
            <mat-select [(ngModel)]="node.type" (selectionChange)="onSelfChange()">
                <mat-option value="string">Text</mat-option>
                <mat-option value="number">Zahl</mat-option>
            </mat-select>
        </mat-form-field>

        @if (node.type === 'number') {
        <div class="limitations">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="small-field limit-field">
                <mat-label>Min</mat-label>
                <input matInput type="number" [(ngModel)]="node.min" (ngModelChange)="onSelfChange()">
            </mat-form-field>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="small-field limit-field">
                <mat-label>Max</mat-label>
                <input matInput type="number" [(ngModel)]="node.max" (ngModelChange)="onSelfChange()">
            </mat-form-field>
        </div>
        }
        }

        <div class="actions">
            <button mat-icon-button class="add-child-button" type="button" (click)="addChild()"
                aria-label="Untergeordnete Property hinzufügen" title="Untergeordnete Property hinzufügen">
                <mat-icon>add_circle_outline</mat-icon>
            </button>
            <button mat-icon-button class="delete-button" color="warn" type="button" (click)="deleteNode()"
                aria-label="Property löschen" title="Property löschen">
                <mat-icon>delete_outline</mat-icon>
            </button>
        </div>
    </div>

    @if (node.expanded && isGroup()) {
    <div class="node-children">
        <div cdkDropList [cdkDropListData]="childNodes" [cdkDropListEnterPredicate]="canDropIntoNode"
            (cdkDropListDropped)="drop($event)" class="child-drop-list"
            [attr.aria-label]="'Properties in ' + (node.name || 'unbenannter Gruppe')">
            @for (child of childNodes; track child.id || $index) {
            <app-template-node-editor [node]="child" [parentNodes]="childNodes" (nodeChange)="onSelfChange()" cdkDrag
                [cdkDragData]="child" (cdkDragStarted)="dragState.start(child)">
            </app-template-node-editor>
            }

            @if (!childNodes.length) {
            <div class="empty-group">Property hier ablegen oder hinzufügen</div>
            }
        </div>
    </div>
    }
</div>
